<script setup>
import { GradeIndicator } from '@/components/ui/badge'

defineProps({
    grade: {
        type: String,
        required: true,
    },
    title: {
        type: String,
        default: '',
    },
    description: {
        type: String,
        default: '',
    },
    colorClass: {
        type: String,
        default: '',
    },
    variant: {
        type: String,
        default: 'default',
    },
})
</script>

<template>
    <div class="flex overflow-hidden rounded-lg border border-slate-200 bg-white">
        <div
            class="w-1.5 shrink-0"
            :class="colorClass"
        ></div>
        <div class="flex flex-1 items-center gap-4 p-4">
            <GradeIndicator :grade="grade" size="lg" :variant="variant" />
            <div class="min-w-0 flex-1">
                <h3
                    v-if="title"
                    class="text-sm font-semibold text-slate-800"
                >
                    {{ title }}
                </h3>
                <slot name="title" />
                
                <p
                    v-if="description"
                    class="mt-0.5 text-xs text-slate-500 line-clamp-2"
                >
                    {{ description }}
                </p>
                <slot name="description" />
            </div>
        </div>
    </div>
</template>
